<template>
  <div style="padding: 4em; text-align: left;">
    <div class="mb-5">
      <h3>Request a new Customer AWS Account</h3>
      <p>Request and account here and direct any questions to #cloud-security.</p>
    </div>
    <p v-if="errors.length">
      <b>Please correct the following error(s):</b>
      <ul>
        <li v-bind:key="error" style="color: red;" v-for="error in errors">{{ error }}</li>
      </ul>
    </p>
    <div style="text-align: left;">
      <form>
        <div class="form-group row">
          <label for="accountName" class="col-sm-3 col-form-label">AWS Account Name</label>
          <div class="col-sm-7">
            <input
              required
              type="text"
              v-model="accountName"
              class="form-control"
              id="accountName"
              placeholder="psaas-customername"
            />
          </div>
        </div>
        <div class="form-group row">
          <label for="accountType" class="col-sm-3 col-form-label">Account type/Cost type</label>
          <div class="col-sm-7">
            <select class="form-control" required v-model="costType">
              <option disabled value>Account type/Cost type</option>
              <option>production</option>
              <option>sales/marketing</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="costSub" class="col-sm-3 col-form-label">Cost subscription</label>
          <div class="col-sm-7">
            <input
              required
              v-model="costSubscription"
              class="form-control"
              id="costSub"
              placeholder="customername@pi or customername@us"
            />
          </div>
        </div>
      </form>
    </div>
    <button class="btn btn-primary mt-5" @click="callApi">Submit</button>
  </div>
</template>

<script>
export default {
  name: "Api",
  data() {
    return {
      apiMessage: null,
      executed: false,
      accountName: null,
      costSubscription: null,
      costType: null,
      errors: []
    };
  },
  methods: {
    slugify(input) {
      return input.toLowerCase().trim().replace(' ', '-');
    },
    validate(sub, type, name) {
      return [
        {val: sub, name: 'Cost Subscription'}, 
        {val: type, name: 'Cost Type'}, 
        {val: name, name: 'Account Name'}].map(el => el.val ? null : `Missing Required field: ${el.name}`).filter(el => !!el)
    },
    async callApi() {
      this.errors = this.validate(this.costSubscription, this.costType, this.accountName)
      if (this.errors.length) {
        return
      }

      const accessToken = await this.$auth.getTokenSilently();

      try { 
        const { data } = await this.$http.post(
          "https://vaj71svhm4.execute-api.us-east-1.amazonaws.com/create",
          {
            data: {
              subscription: this.costSubscription,
              type: this.costType,
              name: this.accountName.startsWith("psaas-")
                ? this.slugify(this.accountName)
                : this.slugify(`psaas-${this.accountName}`)
            }
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        );
        this.apiMessage = data.message;
        this.executed = true;
      } catch (e) {
        console.log(e);
        // this.apiMessage = `Error: the server responded with '${e.response.status}: ${e.response.statusText}'`;
      }
    }
  }
};
</script>
